import * as React from 'react';
import type { SVGProps } from 'react';
const SvgCoinsHandIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.377}
      d="M8.937 5.373a2.41 2.41 0 1 1 .648-3.238M3.754 13.452H5.55q.352 0 .694.084l1.899.461c.412.1.841.11 1.257.03l2.1-.41a2.9 2.9 0 0 0 1.464-.762l1.486-1.445a1.035 1.035 0 0 0 0-1.493 1.11 1.11 0 0 0-1.42-.098l-1.73 1.263c-.248.181-.55.279-.86.279H8.77h1.064c.6 0 1.086-.473 1.086-1.056v-.211c0-.485-.339-.907-.822-1.024l-1.642-.4a3.5 3.5 0 0 0-.816-.097c-.665 0-1.867.55-1.867.55l-2.018.844m9.638-5.869a2.41 2.41 0 1 1-4.82 0 2.41 2.41 0 0 1 4.82 0M1 9.674v3.993c0 .386 0 .579.075.726.066.13.171.235.3.3.148.076.34.076.727.076h.55c.386 0 .579 0 .726-.075a.7.7 0 0 0 .3-.301c.076-.147.076-.34.076-.726V9.674c0-.385 0-.578-.075-.725a.7.7 0 0 0-.301-.301c-.147-.075-.34-.075-.726-.075h-.55c-.386 0-.579 0-.726.075a.7.7 0 0 0-.301.3C1 9.097 1 9.289 1 9.675"
    />
  </svg>
);
export default SvgCoinsHandIcon;
